<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper">
    <ngx-spinner bdColor="rgba(255,255,255,0.8)" size="large" color="#0058ff" type="ball-scale-pulse"
        [fullScreen]="true">
        <p style="color: black"> กำลังโหลดข้อมูล... </p>
    </ngx-spinner>
    <div class="col-lg-12 no-print">
        <div class="card" [ngSwitch]="tab_s">
            <div class="card-header">
                <h1>พิมพ์ใบปะหน้าคำขอสินเชื่อปี {{year.substr(0,2)}}/{{year.substr(2,2)}} โซน {{zone}}</h1>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" (click)="Loadallpromisebyzone();"><i
                            class="fas fa-sync"></i></button>
                    <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                            class="fas fa-minus"></i></button>
                </div>
            </div>

            <div class="row">
                <div class="col-md-auto">
                    <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{'active':tab_s == 1}" id="pills-1" data-toggle="pill"
                                role="tab" aria-selected="true" (click)="tab_s=1">รายการ ส่งคำขอจากเขต
                                <span class="badge badge-warning"></span></a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" [ngClass]="{'active':tab_s == 2}" id="pills-2" data-toggle="pill"
                                role="tab" aria-selected="true" (click)="tab_s=2">ค้นหารายการตามโควตา
                                <span class="badge badge-warning"></span></a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="card-body" *ngSwitchCase="2">
                <div class="row">
                    <div class="col-auto" style="text-align:center">
                        <mat-form-field class="example-form-field" appearance="outline" style="width: 200px;">
                            <mat-label> โควตาชาวไร่ 10 ตัว </mat-label>
                            <input type="text" matInput placeholder="ค้นหาจากตาราง ที่นี่..." [(ngModel)]="txt_fm.fmcf"
                                name="txtS">
                            <button *ngIf="txt_fm.fmcf" matSuffix mat-icon-button aria-label="Clear"
                                (click)="txt_fm.fmcf=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="col-auto">
                        <button mat-raised-button color="primary" (click)="Loaddatabyfmcode();"
                            *ngIf="txt_fm.fmcf.length>0">ค้นหา</button>
                    </div>
                    <div class="col-auto">
                        <button mat-raised-button color="accent" (click)="print_doc(txt_fm.fmcf,1);"
                            *ngIf="databyfm.length>0"><mat-icon>print</mat-icon></button>
                    </div>
                </div>
                <table class="table table-sm" *ngIf="databyfm.length>0">
                    <thead>
                        <tr class="table-success" style="text-align:center">
                            <td>เลขที่คำขอ </td>
                            <td>วันเวลา</td>
                            <td>โซน</td>
                            <td>หมายเลขแปลง</td>
                            <td>ประเภทอ้อย</td>
                            <td>พื้นที่</td>
                            <td>เป้าหมาย</td>
                            <td>เหตุผลการขอ</td>
                            <td>สถานะ</td>
                            <td>จำนวนเงิน</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of databyfm; index as i" style="text-align:center">
                            <td>{{item.docid}}</td>
                            <td>{{item.datepost_th}}</td>
                            <td>{{item.zonePost}}</td>
                            <td>{{item.intlandno}}</td>
                            <td>{{item.canename}} </td>
                            <td>{{item.landvalue | number:'1.0-2'}} </td>
                            <td>{{item.target_yield}} </td>
                            <td>{{item.comment1}}</td>
                            <td>{{item.docdesc}}</td>
                            <td style="text-align:right">{{item.money_amt | number:'1.0-1'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="card-body" *ngSwitchCase="1">
                <mat-form-field appearance="standard">
                    <mat-label>ค้นหาในตาราง</mat-label>
                    <input matInput (keyup)="Filterby($event)" placeholder="ชื่อ เลขที่คำขอ" #input>
                </mat-form-field>

                <div class="mat-elevatiom-z8">
                    <table mat-table [dataSource]="allpromisebyzone" matSort matSortStart="desc" style="width: 100%;">
                        <ng-container matColumnDef="number">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> เลขคำขอ </th>
                            <td mat-cell *matCellDef="let element;"> {{element.docid}} </td>
                        </ng-container>
                        <ng-container matColumnDef="datetime">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> วันเวลา </th>
                            <td mat-cell *matCellDef="let element;"> {{element.datepost_th}} </td>
                        </ng-container>
                        <ng-container matColumnDef="plat_no">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> หมายเลขแปลง </th>
                            <td mat-cell *matCellDef="let element"> {{element.intlandno}} </td>
                        </ng-container>
                        <ng-container matColumnDef="farmername">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> ชื่อ - สกุล </th>
                            <td mat-cell *matCellDef="let element"> {{element.fmname}} </td>
                        </ng-container>
                        <ng-container matColumnDef="mngcomment">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit">ความเห็นผู้จัดการโซน
                            </th>
                            <td mat-cell *matCellDef="let element"> {{element.comment1}} </td>
                        </ng-container>
                        <ng-container matColumnDef="financialamount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> วงเงิน </th>
                            <td mat-cell *matCellDef="let element"> {{element.money_amt|number}} </td>
                        </ng-container>
                        <ng-container matColumnDef="docdesc">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit"> สถานะคำขอ </th>
                            <td mat-cell *matCellDef="let element"> {{element.docdesc}} </td>
                        </ng-container>
                        <ng-container matColumnDef="print">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit">
                                <mat-icon>print</mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <button class="btn btn-primary btn-sm" (click)="print_doc(element.fmcode);">
                                    <mat-icon>print</mat-icon> </button>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="cancle">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header id="Kanit">
                                <mat-icon>highlight_off</mat-icon>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <button class="btn  btn-danger btn-sm" (click)="cancledoc_id(element.docid)"
                                    *ngIf="element.doc_status==0">
                                    <mat-icon>highlight_off</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row class="bg-warning fw-bolder"
                            *matHeaderRowDef="displayaskformoney ; sticky: true;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayaskformoney;"></tr>
                        <!-- Row shown when there is no matching data. -->
                        <tr class="mat-row" *matNoDataRow>
                            <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                        </tr>
                    </table>
                    <mat-paginator [pageSizeOptions]="[1, 5, 10, 25, 50]" showFirstLastButtons
                        aria-label="Select page of periodic elements"></mat-paginator>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-12">
        <div class="card" style="page-break-inside: avoid;">
            <div class="card-body" *ngIf="datafamer.length>0">
                <img src="../../../../assets/images/logo-bsf.png" alt="BSF LOGO">
                <div style="float:right;">
                    <button class="btn btn-primary btn-sm no-print" *ngIf="dataone.length>0" (click)="print_p();">
                        <mat-icon>print</mat-icon> </button>
                    {{time}}
                    <br>
                    <div *ngIf="cnt_over>0" style="text-align:center;border:red; border-width:3px; border-style:solid;">
                        <b style="color: black;">เงินส่งเสริมเกินวงเงิน</b>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12">
                        <div style="float:left;">
                            <i class="far fa-newspaper"></i> แบบเสนอสินเชื่อออนไลน์ ปี
                            25{{year.substr(0,2)}}/25{{year.substr(2,2)}}
                        </div>
                        <div style="float:right;">
                            นอส. : {{supcode}} <u> {{supname}} </u>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div style="background-color: rgb(255, 255, 179);">
                        <p> <i class="far fa-user"></i> โควตา : {{datafamer[0].fmcode_b1}} :
                            {{datafamer[0].fmname}} ที่อยู่ {{datafamer[0].address}} โทร
                            {{datafamer[0].TEL}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>เกรดสินเชื่อ
                                :
                                {{datafamer[0].GradeLoan}}</b>
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>เกรดส่งเสริม :
                                {{datafamer[0].gradeFM1}}.{{datafamer[0].gradeFM2}}.{{datafamer[0].gradeFM3}}.</b>
                        </p>
                    </div>
                </div>
                <div class="row">

                    <table class="table table-sm">
                        <thead>
                            <tr class="table-success" style="text-align:center">
                                <td>เลขที่คำขอ </td>
                                <td>วันเวลา</td>
                                <td>โซน</td>
                                <td>หมายเลขแปลง</td>
                                <td>ประเภทอ้อย</td>
                                <td>พื้นที่</td>
                                <td>เป้าหมาย</td>
                                <td>เหตุผลการขอ</td>
                                <td>สถานะ</td>
                                <td>จำนวนเงิน</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of dataone; index as i" style="text-align:center">
                                <td>{{item.docid}}</td>
                                <td>{{item.datepost_th}}</td>
                                <td>{{item.zonePost}}</td>
                                <td>{{item.intlandno}}</td>
                                <td>{{item.canename}} </td>
                                <td>{{item.landvalue | number:'1.2-2'}} </td>
                                <td>{{item.target_yield}} </td>
                                <td>{{item.type_money_sub}}-{{item.comment1}}</td>
                                <td>{{item.docdesc}}</td>
                                <td style="text-align:right">{{item.money_amt | number:'1.1-1'}}
                                    <a class='fas fa-eye-slash no-print' style='font-size:24;color:red'
                                        (click)="remove_val(item.docid)">
                                    </a>
                                </td>
                            </tr>
                            <tr class="table-success">
                                <td colspan="8"></td>
                                <td>*รวม*</td>
                                <td style="text-align:right"> <U>{{summoney | number:'1.1-1'}}</U> </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- ผลผลิต -->
                <div class="row">

                    <table class="table table-sm">
                        <tbody class="text-bold" *ngFor="let item of retadata">
                            <tr>
                                <td>ผลผลิตปี 60/61</td>
                                <td> {{item.yield6061|number}} </td>
                                <td>วงเงินปุ๋ยอนุมัติ</td>
                                <td><u>{{item.manure_amount|number}}</u></td>
                                <td>วงเงินส่งเสริมอนุมัติ</td>
                                <td> <u>{{item.credit_amount|number}}</u> </td>
                                <td> วงเงินส่งเสริมยังไม่อนุมัติ (P) </td>
                                <td> <u> {{item.credit_amountP|number}}</u> </td>
                            </tr>
                            <tr>
                                <td>ผลผลิตปี 61/62</td>
                                <td>{{item.yield6162|number}}</td>
                                <td>วงเงินปุ๋ยใช้ไป</td>
                                <td><u>{{item.sum_money_manure|number}}</u></td>
                                <td>วงเงินส่งเสริมที่ใช้ไป</td>
                                <td> <u>{{item.sum_money_credit|number}}</u> </td>

                            </tr>
                            <tr>
                                <td>ผลผลิตปี 62/63</td>
                                <td>{{item.yield6263|number}}</td>
                                <td>วงเงินปุ๋ยคงเหลือ</td>
                                <td><u>{{item.manure_left|number}}</u></td>
                                <td>วงเงินส่งเสริมที่คงเหลือ</td>
                                <td> <u>{{item.credit_left|number}}</u> </td>

                            </tr>
                            <tr>
                                <td>ผลผลิตปี 63/64</td>
                                <td>{{item.yield6364|number}}</td>
                                <td>ประเมินอ้อย</td>
                                <td> <u>{{item.sumassess|number}}</u> </td>

                            </tr>
                            <tr>
                                <td>ผลผลิตปี 64/65</td>
                                <td>{{item.yield6465|number}}</td>
                            </tr>

                            <tr>
                                <td>ผลผลิตปี 65/66</td>
                                <td>{{item.yield6566|number}}</td>
                            </tr>

                            <tr>
                                <td>ผลผลิตปี 66/67</td>
                                <td>.........................</td>
                            </tr>
                            <tr *ngIf="year>='6768'">
                                <td>ผลผลิตปี 67/68</td>
                                <td>.........................</td>
                            </tr>
                        </tbody>
                    </table>


                </div>
                <!-- ผลผลิต -->
                <!-- เงินประเมิน -->
                <div class="row" *ngFor="let item of retadata">
                    <div class="col-12">
                        <p>
                            บาทต่อตัน (ประเมิน {{year.substr(0,2)}}/{{year.substr(2,2)}}) ปุ๋ย,ยา
                            <u>{{item.btFactor|number:'1.2-2'}}</u>
                            เงินส่งเสริมที่ใช่ไป <u> {{item.btMoney|number:'1.2-2'}}</u> รวมขอครั้งนี้
                            .................. รวม ...............
                        </p>

                        <p>
                            ระยะยาว (ยอดหนี้ ..................).................... รวมทั้งสิ้น ...................
                        </p>
                        <p>
                            บาทต่อตัน (ผลผลิต {{year.substr(0,2)}}/{{year.substr(2,2)}}) ปุ๋ย,ยา
                            <u>{{item.btFactor6465|number:'1.2-2'}}</u>
                            เงินส่งเสริมที่ใช่ไป <u>{{item.btMoney6364|number:'1.2-2'}}</u> รวมขอครั้งนี้
                            .................. รวม ...............
                        </p>
                        <p>
                            ระยะยาว (ยอดหนี้ ..................).................... รวมทั้งสิ้น ...................
                        </p>
                    </div>
                </div>
                <!-- เงินประเมิน -->

                <!-- ขอเบิก -->
                <div class="row">
                    <div class="col-12">
                        <table class="table table-sm borderless">
                            <tbody>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริม สำหรับปีการผลิตอ้อย
                                        {{year.substr(0,2)}}/{{year.substr(2,2)}}
                                    </td>
                                    <td>......................... บาท วงเงิน ( ) ปกติ ( ) เกินวงเงิน</td>
                                </tr>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริม สินเชื่อระยะยาว</td>
                                    <td>......................... บาท ผ่อนชำระ</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td> ( ) 2 ปี ( ) 3 ปี ( ) 4 ปี ( ) 5 ปี ( ) 6 ปี</td>
                                </tr>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริมค่าซ่อมรถ ชำระปี {{year.substr(0,2)}}/{{year.substr(2,2)}}
                                    </td>
                                    <td>......................... บาท วงเงิน ( ) ปกติ ( ) เกินวงเงิน</td>
                                </tr>
                                <tr>
                                    <td>ขอเบิกเงินส่งเสริมค่าตัด ชำระปี {{year.substr(0,2)}}/{{year.substr(2,2)}}
                                    </td>
                                    <td>......................... บาท วงเงิน ( ) ปกติ ( ) เกินวงเงิน</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="text-bold">( &nbsp; &nbsp; &nbsp; &nbsp;)
                                        &nbsp;ชาวไร่ปรับโครงสร้างหนี้
                                        &nbsp;( &nbsp; &nbsp; &nbsp; &nbsp;) &nbsp;หมดหนี้ &nbsp;( &nbsp; &nbsp;
                                        &nbsp;
                                        &nbsp;) &nbsp;ไม่หมดหนี้</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <!-- ขอเบิก -->

                <!-- More Comemnt -->
                <div class="row">
                    <div class="col-12">
                        ความคิดเห็นเพิ่มเติม
                        <hr class="dashed-line">
                        <hr class="dashed-line">
                        <hr class="dashed-line">
                    </div>
                </div>
                <!-- More Comemnt -->

                <!-- Signature Section -->
                <div class="row mt-4" style="page-break-inside: avoid;">
                    <div class="col-12">
                        <div class="border-0">
                            <table>
                                <tr>
                                    <th style="width:50%"></th>
                                    <th style="width:50%"></th>
                                </tr>
                                <tr>
                                    <td>(1) ลงชื่อ.................................................ชาวไร่ผู้กู้</td>
                                    <td>(2) ลงชื่อ.................................................นักส่งเสริม</td>
                                </tr>
                                <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(........{{datafamer[0].fmname}}........)
                                    </td>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(...........................................................)
                                        รหัสพนักงาน..................</td>
                                </tr>
                                <br>
                                <tr>
                                    <td>(3) ลงชื่อ.................................................ผู้จัดการโซน</td>
                                    <td>(4) ลงชื่อ.................................................หัวหน้าส่วนส่งเสริม
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(...........................................................)
                                        รหัสพนักงาน..................</td>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(...........................................................)
                                        รหัสพนักงาน..................</td>
                                </tr>
                                <br>
                                <tr>
                                    <td>(5) ลงชื่อ.................................................ผจก.ฝ่ายส่งเสริม</td>
                                    <td>(6)
                                        ลงชื่อ................................................ผู้ช่วยกรรมการผู้จัดการ
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(...........................................................)
                                        รหัสพนักงาน..................</td>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(.............นายทรงวุฒิ
                                        พูนสิน.............)
                                    </td>
                                </tr>
                                <br>
                                <tr>
                                    <td>(7)
                                        ลงชื่อ.................................................กรรมการผู้จัดการสายงานจัดหาวัตถุดิบ
                                    </td>
                                    <td> </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(.......นางสาวจิดาภา
                                        พงษ์พิชิตกุล.......)
                                    </td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
                <!-- End Signature Section -->
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>